import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Typography,
  Divider,
  message,
} from 'antd';
import getQueryParams from 'utils/getQueryParams';
import { solicitarRestablecerContrasena } from 'api/usuarios/auth';
import Card from './components/Card';
import './index.scss';

const { Text } = Typography;

const PasswordRecovery = () => {
  const history = useHistory();
  const email = getQueryParams('email', window.location.href);
  if (!email) {
    history.push('/');
  }
  const tryAgain = async () => {
    const response = await solicitarRestablecerContrasena({ email });
    if (response) {
      setTimeout(() => {
        history.push(`recuperacion-de-contrasena?email=${email}`);
        message.info('El correo fue reenviado');
      }, 300);
    }
  };

  return (
    <Card>
      <Text style={{ textAlign: 'center' }}>
        Enviamos un correo electrónico a
        {' '}
        <b>
          {email}
        </b>
        {' '}
        con un enlace para recuperar su contraseña.
        Sigue el enlace para continuar con el proceso.
      </Text>
      <br />
      <Button
        style={{
          width: '150px',
        }}
        className="auth-button"
        onClick={() => history.push('/')}
      >
        Continuar
      </Button>
      <Divider style={{ margin: '10px 0' }} />
      <Text>
        ¿No recibiste nuestro correo electrónico?
        <Button
          type="link"
          style={{
            padding: 0,
            marginLeft: 5,
          }}
          className="auth-button"
          onClick={tryAgain}
        >
          Reenviar
        </Button>
      </Text>
      <br />
      <Text>
        Puedes cerrar esta ventana si ya has terminado.
      </Text>
    </Card>
  );
};

export default PasswordRecovery;
